import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getMedicalInfoInitialValues } from './utils';

import type { RootState } from '../../../../../../../store';

export default function useMedicalInfoInitialValues() {
  const medicalInfo = useSelector(
    (state: RootState) => state.intakeQuestionnaire.intakeQuestionnaireDetails?.medical_info,
  );

  return useMemo(() => getMedicalInfoInitialValues(medicalInfo), [medicalInfo]);
}
